var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg1One = function Svg1One(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.42 53v.5H23.9v-50H13.852l-.134.102C9.968 6.449 5.06 9.207.88 10.235l-.381.093v12.056l.593-.113c3.836-.727 7.17-2.37 10.327-4.396V53Z",
    fill: "#FFD947",
    stroke: "#25241D"
  })));
};

export { Svg1One as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjQyIDUzVjUzLjVIMTEuOTJIMjMuNEgyMy45VjUzVjRWMy41SDIzLjRIMTQuMDJIMTMuODUxN0wxMy43MTc2IDMuNjAxNzhDOS45NjczIDYuNDQ5MjYgNS4wNTk2NCA5LjIwNjg0IDAuODgwNjA2IDEwLjIzNDVMMC41IDEwLjMyODFWMTAuNzJWMjEuNzhWMjIuMzgzN0wxLjA5MzE3IDIyLjI3MTJDNC45MjkxNCAyMS41NDM3IDguMjYzMTUgMTkuOTAxNiAxMS40MiAxNy44NzQ4VjUzWiIgZmlsbD0iI0ZGRDk0NyIgc3Ryb2tlPSIjMjUyNDFEIi8+Cjwvc3ZnPgo=";